
import { Component, Prop, Vue } from 'vue-property-decorator'
import MainLayoutHeader from '../components/MainLayoutHeader.vue'
import MainLayoutMenu from '../components/MainLayoutMenu.vue'
import MainLayoutUser from '../components/MainLayoutUser.vue'

@Component({
  name: 'BuildinLayoutTopLeft',
  components: { MainLayoutHeader, MainLayoutUser, MainLayoutMenu },
})
export default class extends Vue {
  @Prop({ type: String })
  private theme!: 'light' | 'dark'

  // 是否顶部导航固定
  @Prop({ type: Boolean })
  private fixedHeader!: boolean

  // 是否左侧菜单
  @Prop({ type: Boolean })
  private fixedMenu!: boolean

  protected get contentTop() {
    const breadHeight = this.$slots.bread ? 31 : 0
    const tabHeight = this.$slots.tab ? 52 : 0
    return this.fixedHeader ? breadHeight + tabHeight + 'px' : 0
  }
}
